// RFC 8785 (JCS) canonical JSON — the JS twin of the app's
// src/Netcountable.App/E2EE/Jcs.cs. Same restriction: integers only, no
// floats, so number serialization can never diverge between platforms.
//
// Loaded both by Node (server, verify-vectors) and by the browser pages
// (<script type="module">). Keep it dependency-free.

const MAX_SAFE = Number.MAX_SAFE_INTEGER; // 2^53 - 1, mirrors the C# guard

/** Canonical string form of a JS value (objects/arrays/strings/booleans/null/integers). */
export function canonicalize(value) {
  if (value === null) return 'null';

  switch (typeof value) {
    case 'string':
      // JSON.stringify's string escaping IS the RFC 8785 rule.
      return JSON.stringify(value);

    case 'boolean':
      return value ? 'true' : 'false';

    case 'number':
      if (!Number.isSafeInteger(value)) {
        throw new Error(
          `Non-integer (or unsafe) number ${value} in canonical JSON — only integers are allowed in signed/AAD material.`);
      }
      return String(value);

    case 'object':
      if (Array.isArray(value)) {
        return '[' + value.map((v) => canonicalize(v === undefined ? null : v)).join(',') + ']';
      }
      {
        // Default Array.prototype.sort() compares UTF-16 code units — the
        // RFC 8785 property order, and what C# StringComparer.Ordinal does.
        const keys = Object.keys(value).sort();
        const parts = [];
        for (const k of keys) {
          const v = value[k];
          if (v === undefined) continue; // JSON.stringify drops undefined properties; match it
          parts.push(JSON.stringify(k) + ':' + canonicalize(v));
        }
        return '{' + parts.join(',') + '}';
      }

    default:
      throw new Error(`Unsupported type in canonical JSON: ${typeof value}`);
  }
}

/** Canonical UTF-8 bytes. */
export function canonicalizeBytes(value) {
  return new TextEncoder().encode(canonicalize(value));
}
